import React from 'react';
import classNames from 'classnames';
import Logo from './logo.jsx';
import { getPrettyUrl } from '../../helpers.js';
import { ArrowLeft } from '../parts/svg.jsx';

class ArtistIntro extends React.Component{
  _handleLabelClick(){
    this.props.onLabelClick();
  }
  render(){
    const { artist, colors, hiding, hidden } = this.props;

    return [
      <div
        key="intro"
        className={classNames('artist__intro', {
          'artist__intro--hiding': hiding,
          'artist__intro--hidden': hidden
        })}
        style={{
          background: colors.secondary,
          color: colors.primary
        }}>
        <div className="inner inner--flex">
          <h4>{artist.type}</h4>
          <h1 dangerouslySetInnerHTML={{__html: artist.title.rendered}} />
        </div>
      </div>,
      <div key="label" className={classNames('artist__label')} style={{background: colors.secondary, color: colors.primary}} onClick={() => this._handleLabelClick()}>
        <span dangerouslySetInnerHTML={{__html: artist.title.rendered}} />
      </div>,
      <div key="info" className={classNames('artist__info')} style={{background: colors.secondary, color: colors.primary}}>
        <div className="wrapper">
          <div className="artist__info__back" onClick={() => this._handleLabelClick()}>
            <ArrowLeft />
          </div>
          <div className="artist__info__title">
            {artist.title.rendered}
          </div>
          {artist.content.rendered &&
            <div
              className="artist__info__content"
              style={{color: colors.information}}
              dangerouslySetInnerHTML={{ __html: artist.content.rendered }}
              />
          }
          <ul className="artist__info__social-media" style={{color: artist.acf.primary_color}}>
            {artist.acf.instagram_url &&
              <li className="item"><a href={artist.acf.instagram_url} data-color={artist.acf.primary_color} target="_blank">Instagram</a></li>
            }
            {artist.acf.vimeo_url &&
              <li className="item"><a href={artist.acf.vimeo_url} data-color={artist.acf.primary_color} target="_blank">Vimeo</a></li>
            }
            {artist.acf.website_url &&
              <li className="item"><a href={artist.acf.website_url} data-color={artist.acf.primary_color} target="_blank">{getPrettyUrl(artist.acf.website_url)}</a></li>
            }
          </ul>
        </div>
      </div>
    ];
  }
}
export default ArtistIntro;
